import React from 'react'
import { MODAL_DRAWER_IS_CENTER, MODAL_DRAWER_NO_PADDING } from 'app-constants'
import { DrawerModalTemplate } from './templates'
import './style.scss'

export function DrawerModal({ modal }) {
  const { key } = modal || {}

  function getIsCenterClass() {
    const isCenter = MODAL_DRAWER_IS_CENTER.includes(key)
    return isCenter ? '-center' : ''
  }

  function getNoPaddingClass() {
    const noPadding = MODAL_DRAWER_NO_PADDING.includes(key)
    return noPadding ? '-no-padding' : ''
  }

  return (
    <div className='modal-overlay'>
      <div className={`container-modal ${getIsCenterClass()} ${getNoPaddingClass()}`}>
        {DrawerModalTemplate()[key]}
      </div>
    </div>
  )
}
